export const RESEND_VERIFICATION_EMAIL_REQUEST =
  "RESEND_VERIFICATION_EMAIL_REQUEST";
export const RESEND_VERIFICATION_EMAIL_REQUEST_SUCCESS =
  "RESEND_VERIFICATION_EMAIL_REQUEST_SUCCESS";
export const RESEND_VERIFICATION_EMAIL_REQUEST_ERROR =
  "RESEND_VERIFICATION_EMAIL_REQUEST_ERROR";
